import { useState } from 'react';
import { toast } from 'sonner';
import { adminApi } from '@/lib/adminApi';
import { errMsg } from '@/lib/digitalApi';

const Row = ({ cat, onChange }) => {
  const [name, setName] = useState(cat.name);
  const save = async () => {
    try { await adminApi.patch(`/admin/digital-products/categories/${cat.id}`, { name }); toast.success('Category renamed'); onChange(); } catch (e) { toast.error(errMsg(e)); }
  };
  const remove = async () => {
    if (!window.confirm(`Delete category “${cat.name}”?`)) return;
    try { await adminApi.delete(`/admin/digital-products/categories/${cat.id}`); onChange(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="flex items-center gap-3 px-5 py-3" data-testid={`dp-category-row-${cat.id}`}>
      <input value={name} onChange={(e) => setName(e.target.value)} className="flex-1 px-3 py-2 border border-[#eae4d8] rounded-lg text-sm focus:border-[#C8A15A] focus:outline-none" data-testid={`dp-category-name-${cat.id}`} />
      <button type="button" disabled={name.trim() === cat.name || !name.trim()} onClick={save} className="text-xs uppercase tracking-[0.14em] px-3 py-2 rounded-full border border-[#111] disabled:opacity-30" data-testid={`dp-category-save-${cat.id}`}>Rename</button>
      <button type="button" onClick={remove} className="text-xs uppercase tracking-[0.14em] px-3 py-2 text-red-700" data-testid={`dp-category-delete-${cat.id}`}>Delete</button>
    </div>
  );
};

export default function CategoriesPanel({ categories, onChange }) {
  const [name, setName] = useState('');
  const add = async (e) => {
    e.preventDefault();
    try { await adminApi.post('/admin/digital-products/categories', { name }); setName(''); toast.success('Category added'); onChange(); } catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <div className="max-w-2xl" data-testid="dp-categories-panel">
      <p className="text-sm text-[#666] mb-4">Categories group products by topic. Formats (eBook, Workbook, Template, Guide, Toolkit) are set per product.</p>
      <form onSubmit={add} className="flex gap-3 mb-6">
        <input required maxLength={60} value={name} onChange={(e) => setName(e.target.value)} placeholder="New category name" className="flex-1 px-4 py-2 border border-[#eae4d8] rounded-full text-sm focus:border-[#C8A15A] focus:outline-none" data-testid="dp-category-new-name" />
        <button type="submit" className="text-xs tracking-[0.18em] uppercase px-5 py-2 bg-[#111] text-[#FAF8F5] rounded-full" data-testid="dp-category-add">Add</button>
      </form>
      <div className="bg-white border border-[#eae4d8] rounded-xl divide-y divide-[#eae4d8]">
        {categories.map((c) => <Row key={`${c.id}-${c.name}`} cat={c} onChange={onChange} />)}
      </div>
    </div>
  );
}
